import type { MainColumnAriaRole } from '@ms/yammer-web-core-ui/dist/components/AppLayout';
import type { FC, PropsWithChildren } from 'react';
import React, { useMemo } from 'react';

import type { AppContextOptions } from './context';
import AppContext, { defaultOptions } from './context';

export interface AppContextProviderProps {
  readonly mainColumnAriaRole: MainColumnAriaRole;
  readonly options?: Partial<AppContextOptions>;
}

export const AppContextProvider: FC<PropsWithChildren<AppContextProviderProps>> = ({
  mainColumnAriaRole,
  options,
  children,
}) => {
  const contextProps = useMemo(
    () => ({ ...defaultOptions, ...options, mainColumnAriaRole }),
    [options, mainColumnAriaRole]
  );

  return <AppContext.Provider value={contextProps}>{children}</AppContext.Provider>;
};
